import React from "react";
import { RouteComponentProps } from "react-router-dom";
import queryString from "query-string";
import { connect } from "react-redux";
import FeedbackListContainer from "../../Feedback/Components/Common/FeedbackList/FeedbackListContainer";
import { FeedbackCategory, FeedbackSortOption } from "../../Feedback/Constants/feedbackEnums";
import { SearchContext } from "../../Layout/Models/SearchContext";
import { AdvancedSearchSettings } from "../../Layout/Models/AdvancedSearch/AdvancedSearchSettings";
import { IAppState } from "../../Common";

type Props = {};

type StateProps = {
  advancedSearchSettings: AdvancedSearchSettings;
  context: SearchContext;
};

type State = {};

function mapStateToProbs(state: IAppState): StateProps {
  return {
    advancedSearchSettings: state.advancedSearch.settings,
    context: state.searchContext.selectedContext
  };
}

class AdvancedSearchResultsContainer extends React.Component<Props & StateProps, State> {
  constructor(props: Props & StateProps) {
    super(props);

    this.state = {};
  }

  componentDidUpdate(prevProps: Props & StateProps, prevState: State) {}

  render() {
    return (
      <div>
        <h2>Advanced Search Results</h2>
        <FeedbackListContainer
          listId="ADVANCED_SEARCH_RESULTS_LIST"
          sort={FeedbackSortOption.DateCreated}
          startDate={this.props.advancedSearchSettings.startDate}
          endDate={this.props.advancedSearchSettings.endDate}
          context={this.props.context}
          reorderable
          fullscreen
          enableDownload
        />
      </div>
    );
  }
}

export default connect(mapStateToProbs)(AdvancedSearchResultsContainer);
